export default __webpack_public_path__ + "static/media/SeaStars_09.89936d13.png";